import { Group, Modal, Title } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React from "react";
import { useState } from "react";
import { axiosPost } from "../../Helpers";
import Button from "../Button";
import { LoaderWrapper } from "../LoaderWrapper";

const ConfirmToggleModal = ({
  axiosFunction,
  blockURL,
  unblockURL,
  blockingParam,
  openedState,
  setOpenedState,
  cancelled,
  setCancelled,
  setUpdate,
  updateData,
}) => {
  const [loading, setLoading] = useState(false);
  const confirmUpdation = async () => {
    setLoading(true);
    console.log("confirmUpdation");
    let apiResponse = await axiosPost("user/changeStatus", {
      userId: updateData._id,
      status: updateData.status === "active" ? "inactive" : "active",
    });

    if (apiResponse.data.status) {
      showNotification({
        title: "Success",
        message: "Status updated successfully",
        color: "green",
      });
      setUpdate(true);
      setLoading(false);
    } else {
      setLoading(false);
    }
    console.log("apiResponse", apiResponse);
    setCancelled(false);
    setOpenedState(false);
    console.log(
      "\n updateData",
      updateData,
      "\n axiosFunction",
      "\n blockURL",
      blockURL,
      "\n unblockURL",
      unblockURL,
      "\n blockingParam",
      blockingParam,
      "\n openedState",
      openedState,
      "\n cancelled",
      cancelled
    );
  };

  return (
    <Modal
      centered
      opened={openedState}
      onClose={() => {
        setOpenedState(false);
      }}
    >
      <LoaderWrapper loading={loading}>
        <Title order={2} align="center">
          Are you sure you want to perform the toggle?
        </Title>

        <Group mt={"md"} position="center">
          <Button
            title={"Cancel"}
            primary={true}
            fontWeight="700"
            onClick={() => {
              setOpenedState(false);
              setCancelled(false);
            }}
          />

          <Button
            title={"Confirm"}
            primary={true}
            fontWeight="700"
            onClick={confirmUpdation}
          />
        </Group>
      </LoaderWrapper>
    </Modal>
  );
};

export default ConfirmToggleModal;
